import { useCurrentRoute } from 'react-navi';
import { REG_MODAL_FLOW_PARAMS } from '../helpers/common';

export const useIsRegModalFlow = () => {
  const {
    url: { query },
  } = useCurrentRoute();

  const searchParams = new URLSearchParams(query);

  return REG_MODAL_FLOW_PARAMS.some(
    (param) => searchParams.get(param) === 'true'
  );
};
